exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PublicFooter__footer___3foD6 {\n    background: #3a3a3a;\n    font-size: 12px;\n}\n\n.PublicFooter__footer___3foD6.PublicFooter__iframe___1hotg {\n    background: none;\n}\n\n.PublicFooter__footer___3foD6 a {\n    font-size: 12px;\n    color: white;\n}\n\n.PublicFooter__footer___3foD6 a:hover {\n    color: white;\n    text-decoration: underline;\n}\n\n.PublicFooter__footer___3foD6.PublicFooter__iframe___1hotg a {\n    color: black;\n}\n\n.PublicFooter__footer___3foD6 > div {\n    padding-right: 80px;\n}\n", ""]);

// exports
exports.locals = {
	"footer": "PublicFooter__footer___3foD6",
	"iframe": "PublicFooter__iframe___1hotg"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/components/PublicFooter/PublicFooter.css
// module id = 648
// module chunks = 0